/**
 * This file is for displaying all the mentorpick courses
 * that are added in CP Tracker.
 * */
import React, { useEffect, useState } from 'react'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import AddCourse from './AddCourse';
import Util from "../../Service/util";
import { Autocomplete, Fab } from '@mui/material';
import Service from '../../Service/http';
import { Spinner } from 'react-bootstrap';


function Courses() {
  const [coursesData, setCoursesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const util = new Util();
  const service = new Service();
  const [batches, SetBatches] = useState([]);
  let [batch, setBatch] = useState("");
  let [allBatches, setAllBatches] = useState([]);

  useEffect(() => {
    service.get("api/batches").then(json => {
      setAllBatches(json.batches)
    })
      .catch((err) => {
        console.log(err);
      })
  }, [])

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function fetchCoursesData() {
    const isLogin = util.loggedIn();
    const admin = util.isAdmin();
    if (!isLogin && window.location.pathname !== "/login") {
      window.location.replace("/login");
    }
    if (isLogin && admin) {
      service.get("api/course")
        .then((jsonData) => {
          setCoursesData(jsonData.data.map(data => {
            return (
              {
                courseId: data._id,
                slug: data.slug,
                title: data.title,
                batches: data.batches
              }
            )
          }));
          setLoading(false);
        })
        .catch((err) => console.error('error = ', err));
    }
  }

  useEffect(() => {
    fetchCoursesData();
  }, []);


  const updateUserBatches = (ubatch, cid, op) => {

    service.put("api/course", { op, batch: ubatch, courseId: cid })
      .then((jsonData) => {
        fetchCoursesData();
        setLoading(false);
      })
      .catch((err) => console.error('error = ', err));
  };

  let rows = [];
  if (coursesData && coursesData.length > 0) {
    console.log('coursesData => ', coursesData);
    rows = coursesData.map((courseData, index) => {
      return (
        <tr key={index} className='text-center'>
          <td>{index + 1}</td>
          <td>{courseData.courseId}</td>
          <td>{courseData.slug}</td>
          <td>{courseData.title}</td>
          <td> <div className="d-flex justify-content-center">
            {(courseData.batches && courseData.batches.length) ? courseData.batches?.map((batch, ind) => {
              return (
                <div key={ind}>
                  <span className="badge bg-primary m-2">
                    {batch}{" "}
                    <button type="button" onClick={() => updateUserBatches(batch, courseData.courseId, "remove")}>
                      X
                    </button>
                    {" "}
                  </span>
                </div>
              );
            }) : <> No batch </>}
          </div> </td>
          <td>
            <div className=" ">
              <div className="input-group ">
                <select
                  className="form-select text-primary"
                  name="Batch"
                  onChange={(e) => {
                    setBatch(e.target.value)
                    updateUserBatches(e.target.value, courseData.courseId, "add")
                  }}
                >
                  {" "}
                  <option value="select">
                    SELECT BATCHES
                  </option>
                  {allBatches?.map((ele, ind) => {
                    if (batches?.find(element => element == ele) == undefined) {
                      return (
                        <option key={ind} value={ele}>
                          {ele}
                        </option>
                      );
                    }
                  })}
                </select>
              </div>
            </div>
          </td>
        </tr>
      )
    })
  }

  return (
    <>
      <div>
        <h1 style={{ width: '190px', margin: '20px auto 0px auto' }}>All Courses</h1>
        <div className='container d-flex align-items-center justify-content-center my-2 overflow-auto'>
          <table className='table table-striped table-bordered' style={{ marginTop: '20px' }}>
            <thead>
              <tr className='text-center'>
                <th>#</th>
                <th>Course Id</th>
                <th>Course Slug</th>
                <th>Course Name</th>
                <th>Batches </th>
                <th>Select Batch </th>
              </tr>
            </thead>

            <tbody>
              {rows}
            </tbody>
          </table>
        </div>
      </div>
      {loading && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '24px',
          height: '24px',
          backgroundColor: 'rgba(255, 255, 255, 0)',
          zIndex: 1
        }}>
          <Spinner
            animation="border"
            variant="primary"
            style={{ width: '24px', height: '24px' }}
          />
        </div>
      )}
      <Fab
        aria-label="add"
        style={{
          position: "fixed",
          bottom: "50px",
          right: "6px",
          zIndex: 1000,
          width: "60px",
          height: "60px",
        }}
        onClick={handleClickOpen}
      >
        <AddCircleIcon
          sx={{
            color: '#158cba',
            fontSize: '30px'
          }}
        />
      </Fab>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        PaperProps={{
          style: {
            width: 'auto',
            maxWidth: 'none',
            minWidth: '300px',
          },
        }}
      >
        <DialogContent
          style={{
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <AddCourse setLoading={setLoading} fetchCoursesData={fetchCoursesData} />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default Courses